import { render } from "./testCom.vue?vue&type=template&id=2989d5c3&scoped=true"
import script from "./testCom.vue?vue&type=script&lang=js"
export * from "./testCom.vue?vue&type=script&lang=js"

import "./testCom.vue?vue&type=style&index=0&id=2989d5c3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2989d5c3"]])

export default __exports__